import { axiosInstance } from './axios';

import { createAsyncThunk } from '@reduxjs/toolkit';
import APIEndpoints from '../Member/api/APIEndpoints';

export const GetEncryptionKey = createAsyncThunk('getEncryption', async () => {
  return await axiosInstance.get(APIEndpoints.getEncryptionKeyResources());
});

export const GetKeyStoreResources = createAsyncThunk('getKey', async () => {
  return await axiosInstance.get(APIEndpoints.getKeyStoreResources());
});

export const GetBranding = createAsyncThunk('getBranding', async () => {
  return await axiosInstance.get(APIEndpoints.getBranding());
  //const sample = await axiosInstance.get(APIEndpoints.getEncryptionKeyResources());
  //return {
  //Branding: {
  //OID: 'ef9bbe8d-a2a7-467f-98b0-150b86c8e308',
  //Title: 'A1m-QA Health Insurance',
  //LogoOID: 'd8a7a316-c1eb-4f2d-b4b6-ac4603fd35cf',
  //ThemeValues: [
  //{
  //BrandingKey: 'Primary1',
  //BrandingValue: '#884EA2'
  //},
  //{
  //BrandingKey: 'Primary2',
  //BrandingValue: '#DF126C'
  //},
  //{
  //BrandingKey: 'Secondary1',
  //BrandingValue: '#60034C'
  //},
  //{
  //BrandingKey: 'Secondary2',
  //BrandingValue: '#0A7593'
  //},
  //{
  //BrandingKey: 'Primary-Bg',
  //BrandingValue: '#F5F5F5'
  //},
  //{
  //BrandingKey: 'Secondary-Bg',
  //BrandingValue: '#FFF2F8'
  //},
  //{
  //BrandingKey: 'Content-Bg',
  //BrandingValue: '#FFFFFF'
  //},
  //{
  //BrandingKey: 'Primary-Border',
  //BrandingValue: '#E2E2E2'
  //},
  //{
  //BrandingKey: 'Secondary-Border',
  //BrandingValue: '#999999'
  //},
  //{
  //BrandingKey: 'Primary-TextColor',
  //BrandingValue: '#263154'
  //},
  //{
  //BrandingKey: 'Secondary-TextColor',
  //BrandingValue: '#3E4968'
  //},
  //{
  //BrandingKey: 'Link-TextColor',
  //BrandingValue: '#0A7593'
  //},
  //{
  //BrandingKey: 'Primary-Slider-Text',
  //BrandingValue: '#FFE3F0'
  //},
  //{
  //BrandingKey: 'Primary-Card-Text',
  //BrandingValue: '#FFFFFF'
  //},
  //{
  //BrandingKey: 'Error-Bg',
  //BrandingValue: '#FFDEDE'
  //},
  //{
  //BrandingKey: 'Error-TextColor',
  //BrandingValue: '#CC0000'
  //},
  //{
  //BrandingKey: 'Warning-Bg',
  //BrandingValue: '#FFF2E3'
  //},
  //{
  //BrandingKey: 'Warning-TextColor',
  //BrandingValue: '#FF8800'
  //},
  //{
  //BrandingKey: 'Success-Bg',
  //BrandingValue: '#E9FFF3'
  //},
  //{
  //BrandingKey: 'Success-TextColor',
  //BrandingValue: '#007E33'
  //},
  //{
  //BrandingKey: 'Info-Bg',
  //BrandingValue: '#D0F3FF'
  //},
  //{
  //BrandingKey: 'Info-TextColor',
  //BrandingValue: '#0099CC'
  //}
  //],
  //ThemeName: 'Default',
  //HeadingFont: 'Open Sans',
  //ParagraphFont: 'Open Sans'
  //}
  //}
});

export const GetLogoImage = createAsyncThunk('getLogoImage', async (oid) => {
  return await axiosInstance.get(APIEndpoints.getLogo() + oid, {
    responseType: 'arraybuffer',
  });
  //return await axiosInstance.get('https://a1m-qa.eldocomp.com/apigw/v1/dms/document/oid/8b339e4e-cfca-4e38-aceb-606945697f5e',{ responseType: 'arraybuffer' });
});

export const GetContactInfo = createAsyncThunk('getContact', async () => {
  return await axiosInstance.get(APIEndpoints.getContact());
  //return {
  //OID: 'ABCDEFGHIJK',
  //Description: 'For immediate assistance, please call:',
  //Phone1: '1 (800) CALL-NOW',
  //Phone2: '1 (800) 121-2412',
  //Email: 'support@eldocomp.com',
  //Address: '9025 Smoky Hollow Street Niagara Falls, NY 14304',
  //RecordType: 'Public'
  //};
});

export const GetFooterLinks = createAsyncThunk('getFooter', async () => {
  return await axiosInstance.get(APIEndpoints.getLinks());
  //return {
  //Links: [
  //{
  //OID: '1',
  //Title: 'Privacy Policy',
  //Block: 1,
  //BlockTitle: 'Block 1',
  //ContentType: 'Page',
  //ContentReference: 'Internal',
  //ExternalLink: 'null',
  //DocumentOID: 'null',
  //DocumentName: 'null',
  //PageOID: 'fede4bcb-fd87-470f-b15f-a593412efa97',
  //PageTitle: 'Terms and Conditions'
  //},
  //{
  //OID: '2',
  //Title: 'Terms of Use',
  //Block: 1,
  //BlockTitle: 'Block 1',
  //ContentType: 'Page',
  //ContentReference: 'External',
  //ExternalLink: '',
  //DocumentOID: null,
  //DocumentName: 'null',
  //PageOID: '2d4ecca8-59bc-4302-8b7d-50f920ff827a',
  //PageTitle: 'null'
  //},
  //{
  //OID: '22',
  //Title: 'Legal',
  //Block: 1,
  //BlockTitle: 'Block 1',
  //ContentType: 'Document',
  //ContentReference: 'null',
  //ExternalLink: 'null',
  //DocumentOID: 'f1147658-2b6e-45f7-ac57-af6d15a72ffa',
  //DocumentName: 'Document Name',
  //PageOID: 'null',
  //PageTitle: ''
  //},
  //{
  //OID: '23',
  //Title: 'Contact Us',
  //Block: 1,
  //BlockTitle: 'Block 1',
  //ContentType: 'Page',
  //ContentReference: 'null',
  //ExternalLink: 'null',
  //DocumentOID: 'null',
  //DocumentName: 'null',
  //PageOID: '95691695-94ca-4ae6-bbe6-f90aa064abec',
  //PageTitle: 'Terms and Conditions'
  //},
  //{
  //OID: '11',
  //Title: 'Privacy Policy',
  //Block: 2,
  //BlockTitle: 'Block 2',
  //ContentType: 'Page',
  //ContentReference: 'null',
  //ExternalLink: 'null',
  //DocumentOID: 'null',
  //DocumentName: 'null',
  //PageOID: 'fede4bcb-fd87-470f-b15f-a593412efa97',
  //PageTitle: 'Terms and Conditions'
  //},
  //{
  //OID: '21',
  //Title: 'Terms of Use',
  //Block: 2,
  //BlockTitle: 'Block 2',
  //ContentType: 'External Link',
  //ContentReference: 'null',
  //ExternalLink: 'https://javelina.mphasis.com/home.html',
  //DocumentOID: null,
  //DocumentName: null,
  //PageOID: null,
  //PageTitle: 'null'
  //},
  //{
  //OID: '26',
  //Title: 'Legal',
  //Block: 2,
  //BlockTitle: 'Block 2',
  //ContentType: 'Document',
  //ContentReference: 'null',
  //ExternalLink: 'null',
  //DocumentOID: 'f1147658-2b6e-45f7-ac57-af6d15a72ffa',
  //DocumentName: 'abc',
  //PageOID: 'null',
  //PageTitle: ''
  //},
  //{
  //OID: '27',
  //Title: 'Contact Us',
  //Block: 2,
  //BlockTitle: 'Block 2',
  //ContentType: 'Page',
  //ContentReference: 'null',
  //ExternalLink: 'null',
  //DocumentOID: 'null',
  //DocumentName: 'null',
  //PageOID: '95691695-94ca-4ae6-bbe6-f90aa064abec',
  //PageTitle: 'Terms and Conditions'
  //},
  //{
  //OID: '31',
  //Title: 'Privacy Policy',
  //Block: 3,
  //BlockTitle: 'Block 3',
  //ContentType: 'Page',
  //ContentReference: 'null',
  //ExternalLink: 'null',
  //DocumentOID: 'null',
  //DocumentName: 'null',
  //PageOID: 'fede4bcb-fd87-470f-b15f-a593412efa97',
  //PageTitle: 'Terms and Conditions'
  //},
  //{
  //OID: '32',
  //Title: 'Terms of Use',
  //Block: 3,
  //BlockTitle: 'Block 3',
  //ContentType: 'External Link',
  //ContentReference: 'null',
  //ExternalLink: 'https://javelina.mphasis.com/home.html',
  //DocumentOID: null,
  //DocumentName: null,
  //PageOID: null,
  //PageTitle: 'null'
  //},
  //{
  //OID: '42',
  //Title: 'Legal',
  //Block: 3,
  //BlockTitle: 'Block 3',
  //ContentType: 'Document',
  //ContentReference: 'null',
  //ExternalLink: 'null',
  //DocumentOID: '4c3ab07f-61a0-40cd-8d3d-f8e06cbfb0c1',
  //DocumentName: 'image',
  //PageOID: 'null',
  //PageTitle: ''
  //},
  //{
  //OID: '34',
  //Title: 'Contact Us',
  //Block: 3,
  //BlockTitle: 'Block 3',
  //ContentType: 'Page',
  //ContentReference: 'null',
  //ExternalLink: 'null',
  //DocumentOID: 'null',
  //DocumentName: 'null',
  //PageOID: '95691695-94ca-4ae6-bbe6-f90aa064abec',
  //PageTitle: 'Terms and Conditions'
  //}
  //]
  //};
});

export const GetMediaLinks = createAsyncThunk('getMedia', async () => {
  return await axiosInstance.get(APIEndpoints.getSocialLinks());
  //return {
  //SocialMediaLinks: [
  //{
  //OID: 'ABCDEFGHIJKLMNOPQR',
  //MediaType: 'YouTube',
  //URL: 'http://youtube.com'
  //},
  //{
  //OID: 'ABCDEFGHIJNOPQR',
  //MediaType: 'Facebook',
  //URL: 'http://Facebook.com'
  //},
  //{
  //OID: 'ABCGHIJKLMNOPQR',
  //MediaType: 'Twitter',
  //URL: 'http://Twitter.com'
  //}
  //]
  //};
});

export const GetPageContent = createAsyncThunk(
  'getPageContent',
  async (oid) => {
    return await axiosInstance.get(
      APIEndpoints.getPageContent() + '/oid/' + oid,
    );
  },
);
